import React, { useEffect, useRef } from 'react';
import { IfcViewerAPI } from 'web-ifc-viewer';
import * as THREE from 'three';
const IfcViewer = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const ifcUrl = params.get('ifcUrl');

        if (!ifcUrl) {
          console.error('Missing "ifcUrl" query parameter.');
          return;
        }

        const url = new URL(ifcUrl);
        const allowedDomain = /\.aedrix\.com$/;

        if (!allowedDomain.test(url.hostname)) {
          console.error('Blocked: Wrong IFC URL');
          return;
        }
        const container = containerRef.current;

        // Setup viewer
        const viewer = new IfcViewerAPI({ container, backgroundColor: new THREE.Color(0xffffff) });
        viewer.grid.setGrid();
        viewer.axes.setAxes();

        // Set the path for WASM file
        viewer.IFC.setWasmPath('../../');

        // Load IFC file
        const loadModel = async () => {
          await viewer.IFC.loadIfcUrl(ifcUrl);
        };

        loadModel();
    }, []);

    return <div ref={containerRef} style={{ width: '100%', height: '800px' }} />;
};

export default IfcViewer